import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { darkPalette, lightPalette } from "./palette";
import { typography } from "./typography";
import { components } from "./components";

function buildTheme(mode: "dark" | "light") {
  const theme = createTheme({
    palette: mode === "dark" ? darkPalette : lightPalette,
    typography,
    shape: { borderRadius: 16 },
    components,
    breakpoints: {
      values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }
    }
  });
  return responsiveFontSizes(theme, { factor: 2.2 });
}

export const darkTheme  = buildTheme("dark");
export const lightTheme = buildTheme("light");

export type ThemeMode = "dark" | "light";
